module.exports = __webpack_public_path__ + "static/media/Arbeidsminne-trial-ex.6f4bc856.mp3";